import {
  all,
  takeLatest,
  takeEvery,
  put,
  call,
  select,
} from "redux-saga/effects";
import * as requests from "../../helpers/requests";
import config from "../../config";
import * as act from "./constants";
import { store } from "../store";
import { cloneDeep } from "lodash";

const uuid4 = require("uuid/v4");

const apiPUrl = `${config.api_url}/webapi/v1`;

const reorder_days = (list, startIndex, endIndex) => {
  let result = Array.from(list);
  let split_out = list.reduce(
    (accum, value) => {
      if (value.type === "session") accum.work_on.push(value);
      else accum.flow_through.push(value);
      return accum;
    },
    {
      work_on: [],
      flow_through: [],
    }
  );

  const [removed] = split_out.work_on.splice(startIndex, 1);
  split_out.work_on.splice(endIndex, 0, removed);
  split_out.work_on = split_out.work_on.map((r, index) => ({
    ...r,
    order: index,
    day_name: index + 1,
  }));
  return split_out.work_on.concat(split_out.flow_through);
};

export const reorder_exercises = (list, startIndex, endIndex) => {
  let result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  result = result.map((r, index) => ({
    ...r,
    order: index,
  }));
  return result;
};

function* REORDER_ACTIVE_PROGRAM_DAYS(action) {
  let { activeprogram } = store.getState().ActiveProgram;
  activeprogram = cloneDeep(activeprogram);

  let days = reorder_days(
    [...activeprogram.days],
    action.payload.source,
    action.payload.dest
  );
  activeprogram = { ...activeprogram, days };
  yield put({
    type: "SET_ACTIVE_PROGRAM",
    payload: activeprogram,
  });
  for (let day of days) {
    try {
      yield call(
        requests.patch,
        `${config.api_url}/webapi/v1/day_partial/${day.id}/`,
        JSON.stringify(day)
      );
    } catch (err) {
      console.log("requests.patch in REORDER_ACTIVE_PROGRAM_DAYS", err);
    }
  }
}

export const reorder_blocks = (list, block_id, startIndex, endIndex) => {
  list = Array.from(list);
  // console.log(list);
  let block = list.find((b) => b.id === block_id);

  let split_out = list.reduce(
    (accum, value) => {
      if (value.type === block.type) accum.work_on.push(value);
      else accum.flow_through.push(value);
      return accum;
    },
    {
      work_on: [],
      flow_through: [],
    }
  );

  const [removed] = split_out.work_on.splice(startIndex, 1);
  split_out.work_on.splice(endIndex, 0, removed);

  split_out.work_on = split_out.work_on.map((r, index) => ({
    ...r,
    identifier: index,
  }));
  return split_out.work_on.concat(split_out.flow_through);
};

function* PASTE_SESSION_TO_ACTIVE_PROGRAM(action) {
  let { activeprogram } = store.getState().ActiveProgram;
  activeprogram = cloneDeep(activeprogram);

  let newid = uuid4();
  activeprogram.days.splice(action.payload.dest_index, 0, {
    type: "loader",
    id: newid,
  });
  activeprogram.days.map((d, index) => {
    d.order = index;
    d.day_name = index + 1;
  });

  //we need this to display the loading indicator
  yield put({
    type: "SET_ACTIVE_PROGRAM",
    payload: activeprogram,
  });

  let { sessions } = store.getState().RightBar;
  let s = sessions.find((s) => s.id === action.payload.session_id);
  //make sure all children get new ids so they copy across and
  //also set program_id to active program for copying across programs
  if (!s) {
    console.log(
      "had to fetch the session from the server, probably should look at why here"
    );
    s = yield call(
      requests.get,
      `${config.api_url}/webapi/v1/day/${action.payload.session_id}/`
    );
  }
  try {
    s.entities.map((e) => {
      e.id = uuid4();
      delete e.program_day_id;
      e.exercises.map((e) => {
        e.id = uuid4();
        delete e.program_series_id;
      });
    });
    s.id = uuid4();
    s.program_id = activeprogram.id;
    s.calendar_day = "{}";

    activeprogram = cloneDeep(activeprogram);
    let day = yield call(
      requests.post,
      `${config.api_url}/webapi/v1/day/`,
      JSON.stringify(s)
    );

    activeprogram = cloneDeep(store.getState().ActiveProgram.activeprogram);
    let index = activeprogram.days.findIndex((d) => d.id === newid);
    activeprogram.days.splice(index, 1, day);
    activeprogram.days.map((d, index) => {
      d.order = index;
      d.day_name = index + 1;
    });
    yield put({
      type: "SET_ACTIVE_PROGRAM",
      payload: activeprogram,
    });

    for (let day of activeprogram.days) {
      if (day.type !== "loader") {
        try {
          yield call(
            requests.patch,
            `${config.api_url}/webapi/v1/day_partial/${day.id}/`,
            JSON.stringify(day)
          );
        } catch (err) {
          console.log("requests.patch in PASTE_SESSION_TO_ACTIVE_PROGRAM", err);
        }
      }
    }
  } catch (err) {
    console.log("error in PASTE_SESSION_TO_ACTIVE_PROGRAM", err);
  }
}

function* REORDER_ACTIVE_DAY_BLOCKS(action) {
  let { activeprogram } = store.getState().ActiveProgram;
  activeprogram = cloneDeep(activeprogram);
  let { selectedDayId } = store.getState().Programming;
  let selectedDay = activeprogram.days.find((d) => d.id === selectedDayId);
  selectedDay = cloneDeep(selectedDay);

  let blocks = reorder_blocks(
    selectedDay.entities,
    action.payload.id,
    action.payload.source,
    action.payload.dest
  );

  let day = { ...selectedDay, entities: blocks };
  let index = activeprogram.days.findIndex((d) => d.id === day.id);
  activeprogram = { ...activeprogram };
  activeprogram.days.splice(index, 1, day);
  yield put({
    type: "SET_ACTIVE_PROGRAM",
    payload: activeprogram,
  });

  for (let block of blocks) {
    try {
      yield call(
        requests.patch,
        `${config.api_url}/webapi/v1/series/${block.id}/`,
        JSON.stringify(block)
      );
    } catch (err) {
      console.log("requests.patch in REORDER_ACTIVE_DAY_BLOCKS", err);
    }
  }
}

const insert_at_destination = (list, block, index, replace = false) => {
  let split_out = list.reduce(
    (accum, value) => {
      if (value.type === block.type) accum.work_on.push(value);
      else accum.flow_through.push(value);
      return accum;
    },
    {
      work_on: [],
      flow_through: [],
    }
  );
  split_out.work_on.splice(index, replace ? 1 : 0, block);
  split_out.work_on = split_out.work_on.map((r, index) => ({
    ...r,
    identifier: index,
  }));
  let ret = split_out.work_on.concat(split_out.flow_through);
  console.log(ret);
  return ret;
};

function* PASTE_BLOCK_TO_ACTIVE_DAY(action) {
  try {
    let { activeprogram } = store.getState().ActiveProgram;
    activeprogram = cloneDeep(activeprogram);

    let { selectedDayId } = store.getState().Programming;
    console.log("selectedDayId in PASTE_BLOCK_TO_ACTIVE_DAY", selectedDayId);
    let selectedDay = activeprogram.days.find((d) => d.id === selectedDayId);
    selectedDay = cloneDeep(selectedDay);

    let { blocks } = store.getState().RightBar;
    let b = cloneDeep(blocks.find((b) => b.id === action.payload.block_id));

    //need to update ids on the exercises so that they are created
    b.exercises = b.exercises.map((ex) => {
      delete ex.program_series_id;
      return { ...ex, id: uuid4() };
    });
    b.program_day_id = selectedDay.id;
    b.type = action.payload.destination.droppableId;
    delete b.program_series_id;

    selectedDay = cloneDeep(selectedDay);
    selectedDay.entities = insert_at_destination(
      selectedDay.entities,
      {
        type: action.payload.destination.droppableId,
        display_loader_override: true,
        id: uuid4(),
        exercises: [],
      },
      action.payload.destination.index
    );

    let dayindex = activeprogram.days.findIndex((d) => d.id === selectedDay.id);
    activeprogram = { ...activeprogram };
    activeprogram.days.splice(dayindex, 1, selectedDay);

    //we need this to display the loading indicator
    yield put({
      type: "SET_ACTIVE_PROGRAM",
      payload: activeprogram,
    });

    let block = yield call(
      requests.post,
      `${config.api_url}/webapi/v1/series/`,
      JSON.stringify(b)
    );

    let replace = true;
    selectedDay.entities = insert_at_destination(
      selectedDay.entities,
      block,
      action.payload.destination.index,
      replace
    );

    let day = cloneDeep(selectedDay);
    dayindex = activeprogram.days.findIndex((d) => d.id === day.id);
    activeprogram = { ...activeprogram };
    activeprogram.days.splice(dayindex, 1, day);

    yield put({
      type: "SET_ACTIVE_PROGRAM",
      payload: activeprogram,
    });
    for (let e of selectedDay.entities) {
      try {
        yield call(
          requests.patch,
          `${config.api_url}/webapi/v1/series/${e.id}/`,
          JSON.stringify(e)
        );
      } catch (err) {
        console.log("requests.patch in PASTE_BLOCK_TO_ACTIVE_DAY", err);
      }
    }
  } catch (err) {
    console.log("error in PASTE_BLOCK_TO_ACTIVE_DAY", err);
  }
}

export default function* programmingSagaWatcher() {
  yield all([
    takeLatest("REORDER_ACTIVE_PROGRAM_DAYS", REORDER_ACTIVE_PROGRAM_DAYS),
    takeLatest("REORDER_ACTIVE_DAY_BLOCKS", REORDER_ACTIVE_DAY_BLOCKS),
    takeEvery(
      "PASTE_SESSION_TO_ACTIVE_PROGRAM",
      PASTE_SESSION_TO_ACTIVE_PROGRAM
    ),
    takeLatest("PASTE_BLOCK_TO_ACTIVE_DAY", PASTE_BLOCK_TO_ACTIVE_DAY),
  ]);
}
